import { TbPlayerPlay } from "react-icons/tb";
import { HiOutlineInformationCircle } from "react-icons/hi";
import { RiDownloadCloud2Line } from "react-icons/ri";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Dropdown, DropdownButton, SplitButton } from "react-bootstrap";
import { useContext } from "react";
import AuthenticationContext from "../../Authentication/AuthenticationContext.ts";
import placeholder from "../../assets/images/New folder/placeholder.jpg";
import TrackContext from "context/TracksContext";
import sendRequest from "hooks/useAxios";
import { showSwalError, showSwalSuccess } from "utils/swal";
import Swal from "sweetalert2";
import { NavLink, useNavigate } from "react-router-dom";

export default function ChoosenItem({
  value,
  id,
  src,
  title,
  setShowAudioPlayer,
  setAddTrackModal,
  setAboutTrackModal,
  setSelectedAlbum,
  trackLists,
  selectedPlayList,
  setSelectedTrack,
}) {
  const nav = useNavigate();
  const { setTypeModalTrack, setvalueEditModal, setUpdateList, updateList } =
    useContext(TrackContext);
  const auth = useContext(AuthenticationContext);
  const onClickHandlerDelete = () => {
    sendRequest("audio/edit_track", {
      audioId: value.id,
      status: -1,
    }).then((res) =>
      res.data.status === 1
        ? (showSwalSuccess("ترک با موفقیت حذف شد."), setUpdateList(!updateList))
        : res.data.status === -1
          ? showSwalError("ورودی ها را به درستی وارد کنید.")
          : res.data.status === -2 || res.data.status === -3
            ? showSwalError("مشکلی در حذف ترک وجود دارد، دوباره تلاش کنید.")
            : ""
    );
  };
  const DropDownCustom = () => {
    return (
      <DropdownButton
        align={{ lg: "start" }}
        title={<BsThreeDotsVertical color="darkgray" />}
        id="dropdown-menu-align-responsive-1"
      >
        <Dropdown.Item
          eventKey="1"
          onClick={(e) => {
            Swal.fire({
              title: "آیا از حذف این آیتم مطمئن هستید؟",
              // icon: icon,
              showCancelButton: true,
              confirmButtonColor: "#fe0000",

              confirmButtonText: "حذف",
              cancelButtonText: "انصراف",
            }).then((result) => {
              if (result.isConfirmed) {
                onClickHandlerDelete();
              }
            });
          }}
        >
          حذف
        </Dropdown.Item>
        <Dropdown.Item
          eventKey="2"
          onClick={() => {
            setAddTrackModal(true);
            setTypeModalTrack("edit");
            setvalueEditModal(value);
          }}
        >
          ویرایش
        </Dropdown.Item>
      </DropdownButton>
    );
  };
  return (
    <div style={{ color: "white" }} className="d-flex mt-4 choosen-item">
      <img
        className="rounded"
        src={
          value.fileId != 0
            ? //  && value.file.length !== 0
            `http://ava.tatdemo.ir/${value.file.path}`
            : placeholder
        }
        style={{ width: 90, height: 90, objectFit: "contain" }}
      />
      <div className="ms-3 my-2">
        <div className="d-flex justify-content-between">
          <h4 className="test" style={{ minHeight: 30 }}>
            {value.title}
          </h4>
          {auth.isLogged && <DropDownCustom />}
        </div>
        <div className="d-flex">
          <div
            onClick={() => {
              window.open(`http://ava.tatdemo.ir/${src}`);
            }}
            // to={`/${src}`}
            style={{ border: `1px solid darkGray`, width: 40, height: 40 }}
            className="rounded-circle p-1 d-flex align-items-center justify-content-center cursor-pointer"
          >
            <RiDownloadCloud2Line
              color={"darkGray"}
              style={{ width: 22, height: 22 }}
            />
          </div>
          <div
            style={{ border: `1px solid darkGray`, width: 40, height: 40 }}
            className="rounded-circle p-1 d-flex align-items-center justify-content-center mx-3 cursor-pointer"
            onClick={() => {
              setAboutTrackModal(true);

              setSelectedAlbum(value);
            }}
          >
            <HiOutlineInformationCircle
              color={"darkGray"}
              style={{ width: 22, height: 22 }}
            />
          </div>
          <div
            style={{ border: `1px solid darkGray`, width: 40, height: 40 }}
            className="rounded-circle p-1 d-flex align-items-center justify-content-center cursor-pointer"
            onClick={() => {
              // setShowAudioPlayer(true);
              selectedPlayList(trackLists);
              setSelectedTrack(value);
            }}
          >
            <TbPlayerPlay
              color={"darkGray"}
              style={{ width: 22, height: 22 }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
